<script>
import { required } from "vuelidate/lib/validators";
import { digitalLoadMethods, digitalLoadComputed, layoutMethods, exportMethods,erpFixMessages, erpUserRolesMethods, liteEloadDropdownMethods, liteEloadDropdownComputed } from '@/state/helpers';
import Swal from 'sweetalert2';
import { getModuleAccess, showAccessRestrictedModal } from '@/router/helper.js'
import Moment from 'moment';
import 'moment-timezone';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

/**
 * E-Load list component
 */
export default {
  page: {
    title: "Peddlr Lite Manager - E-Load SKU",
  },
  data() {
    return {
      promoList: Object,
      title: "Peddlr Lite Manager - E-Load SKU",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        { key: 'promoId', label: 'Promo ID', sortable: true, tdClass: 'align-middle' },
        { key: 'promoName', label: 'Promo Name', sortable: true },
        { key: 'promoCode', label: 'Promo Code', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'category', label: 'Category', sortable: true },
        { key: 'special_category', label: 'Special Category', sortable: true },
        { key: 'network', label: 'Network', sortable: true },
        { key: 'service', label: 'Service', sortable: true },
        { key: 'description', label: 'Description', sortable: false },
        { key: 'amount', label: 'Amount', sortable: true, thClass: 'text-end' },
        { key: 'validity', label: 'Validity', sortable: false, tdClass: 'text-center' },
        { key: 'input_type', label: 'Input Type', sortable: false }
      ],
      eload: {
        promoId: "",
        name: "",
        validity: "",
        amount: "",
        description: "",
        network: "",
        category: "",
        status: 0,
        error: "",
      },
      searchValue: {
        searchField: null,
        search: "",
        status: null,
        dateRange: null,
        category: null,
        sort: 'id',
        orderDesc: true,
        service: null,
        network: null,
      },
      searchListPromo: [
        { text: "Search All", value: null },
        { text: "Network", value: 'network' },
        { text: "Promo Name", value: 'promo_name' },
        { text: "Validity", value: 'promo_validity' }
      ],
      statusList: [
        { text: "All", value: null },
        { text: "Active", value: 1 },
        { text: "Inactive", value: 0 }
      ],
      categoryList:[{ text: "All", value: null }],
      searching: false,
      eloadServiceOptions: [{ text: "All", value: null }],
      eloadPromoModule: {
        access: {
          create: false,
          update: false,
          delete: false
        }
      },
      eloadNetworkOptions: [
        { text: "All", value: null },
      ],
      promos: [],
    };
  },
  validations: {
    eload: {
      name: {required},
      validity: {required},
      amount: {required},
      description: {required},
      network: {required},
      status: {required},
      category: {required}
    },
  },
  computed: {
    ...digitalLoadComputed,
    ...liteEloadDropdownComputed,
    ...erpFixMessages,
    /**
     * Total no. of records
     */
    rows() {
      return this.promoList.length;
    },
    sliceDescription: function(desc) {
      if (desc.length > 10) {
        return desc.slice(0, 10);
      }
      return desc;
    },
    loadCategoryOptions: {
      get(){
        return this.loadCategoryList.map(category => {
          return { 'text': category.categoryName, 'value': category.categoryName }
        });
      }
    },
    networkOptions: {
      get(){
        return this.loadNetworkList.map(n => Object.assign({
          text: n.name,
          value: n.name
        }));
      }
    }
  },
  mounted: async function() {
    this.getPromoList();
    this.getEloadCategoryList();
    this.getNetworks();
    this.changeTitle({title: 'E-Load SKU'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'Peddlr Lite Manager', to: { name: 'E-Load Lite SKU Manager'} },
        { text: 'E-Load SKU', to: { name: 'E-Load Lite SKU Manager'} }
      ]
    });
    this.actionNetwork({
        action: "services",
        body: {}
    })
    .then(async (res) => {
      // sort res.rows into ascending order
      let sortedList = await this.sortOptions('name', res.rows);

      for(let c of sortedList){
        this.eloadServiceOptions.push({text:c["name"], value:c["id"]})
      }
    }).catch((e)=>{
      console.log("error while setup of parent category option",e);
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eLoad', 'eLoad Promo')
      .then((access) => this.eloadPromoModule.access = access);
    
  },
  watch: {
    'searchValue.network': function() {
      // reset category dropdown to include default 'All' and reload based on selected network
      this.categoryList = [{ text: "All", value: null }];
      this.getEloadCategoryList();
    }
  },
  methods: {
    ...layoutMethods,
    ...digitalLoadMethods,
    ...liteEloadDropdownMethods,
    ...exportMethods,
    ...erpUserRolesMethods,
    async onExport(){
      var self = this;
      await this.onPageUpdate("reset").then(function(){
        // console.log("check this:",self.loadPromoTotalRows);
        if(self.loadPromoTotalRows == 0){
          Swal.fire("Failed!", self.exportNullPrompt, "warning");
        }else{
          let params = {
            ...self.searchValue,
            email: JSON.parse(localStorage.getItem('userData')).email
          };

          // call backend export action for promo list
          self.actionLoadPromo({ action: 'export-promo-list', body: params })
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        }
      })
    },
    async getPromoList() {
      await this.getLoadPromoList({
        body: {
          page: this.currentPage,
          rows: this.perPage
        }
      }).then(async () => {
        let promosList = [];
        promosList = this.loadPromoList.map(item => ({ ...item, isChecked: false }));
        this.promos = JSON.parse(JSON.stringify(promosList));
        // console.log('promosList: ', promosList)
      })
    },
    async searchPromo() {
      await this.getLoadPromoList({
        body: {
          page: this.currentPage ,
          rows: this.perPage,
          ...this.searchValue
        }
      }).then(async () => {
        let promosList = [];
        promosList = this.loadPromoList.map(item => ({ ...item, isChecked: false }));
        this.promos = JSON.parse(JSON.stringify(promosList));
      })
    },
    async onPageUpdate(reset = "") {
      if(this.searching || this.searchValue.status != null || this.searchValue.dateRange != null 
          || this.searchValue.sort != null || this.searchValue.payment_method != null 
          || this.searchValue.network != null
          || this.searchValue.service != null || this.searchValue.category != null) {
        if(reset == "reset"){
          this.currentPage = 1
        }

        await this.searchPromo()
      } else {
        await this.getPromoList()
      }

    },
    onSearch() {
      this.currentPage = 1
      if (this.searchValue.search) {
        this.searching = true
        this.searchPromo()
      } else {
        this.searching = false
        this.searchValue = {
          search: null,
          searchField: null,
        }
        this.getPromoList()
      }
    },

    getServiceName(serviceId) {
      if (serviceId == null) return null;
      const found = this.eloadServiceOptions.find(s => s.value == serviceId);
      return found ? found.text : null;
    },
    getSpecialCategories(item) {
      if (!item) return [];
      if (item.promoSpecialCategories && Array.isArray(item.promoSpecialCategories) && item.promoSpecialCategories.length) {
        return item.promoSpecialCategories.map(c => c.category_name || c.categoryName || c);
      }
      if (item.promoSpecialCategoryName) return [item.promoSpecialCategoryName];
      if (item.promoSpecialCategory) return [item.promoSpecialCategory];
      return [];
    },
    async getEloadCategoryList() {
      const self = this;
      try {
        const params = { rows: 9999 };
        // If a specific network is selected, pass it as a query filter so backend returns only that network's categories
        if (this.searchValue && this.searchValue.network) {
          params.network = this.searchValue.network;
        }

        const res = await this.fetchLiteNetworkCategoryList(params);
        const rows = (res && res.message && res.message.rows) ? res.message.rows : [];
        const sortedList = await this.sortOptions('categoryName', JSON.parse(JSON.stringify(rows || [])));
        for (const data of sortedList) {
          const isSpecial = data.isSpecialCategory == 1 || data.is_special == 1 || data.isSpecial == 1;
          const networkName = data.networkName || data.network || '';
          const display = `${data.categoryName}${networkName ? ' - ' + networkName : ''}${isSpecial ? ' (SC)' : ''}`;
          self.categoryList.push({ text: display, value: data.categoryName });
        }
      } catch (e) {
        console.warn('Failed to fetch network category list', e);
      }
    },
    async getNetworks() {
      // reset options (keep the default 'All')
      this.eloadNetworkOptions = [{ text: "All", value: null }];

      try {
        await this.getEloadNetworkList({ rows: 99999, order: 'ASC' });
        const sortedList = await this.sortOptions('name', JSON.parse(JSON.stringify(this.loadNetworkList || [])));

        for (const network of sortedList) {
          if (network && (network.status == null || network.status == 'a')) {
            this.eloadNetworkOptions.push({ text: network.name, value: network.name });
          }
        }
      } catch (e) {
        console.warn('Failed to load network list for filters', e);
      }
    },
    onNetworkChange() {
      this.categoryList = [{ text: "All", value: null }];
      this.getEloadCategoryList();
      this.searchValue.category = null; // reset category filter when network changes
    },
    onDisplayChange(){
      // console.log(this.loadPromoTotalRows,this.perPage,this.loadPromoList.length,(this.loadPromoList.length < this.loadPromoTotalRows && this.loadPromoList.length != this.perPage));
      if(
        (this.loadPromoList.length < this.loadPromoTotalRows && this.loadPromoList.length != this.perPage) || // condition for incrementing display per page
        (this.loadPromoList.length == this.loadPromoTotalRows && this.perPage < this.loadPromoList.length) // condition for decreasing display per page
        ){
        this.onPageUpdate('reset')
      }
    },
    eloadPromoSort(ctx){
      this.searchValue.sort = ctx.sortBy;
      this.searchValue.orderDesc = ctx.sortDesc;
      // console.log(">> sorting",this.searchValue);
      if(this.prev_sort != ctx.sortBy){
        this.prev_sort = ctx.sortBy
        this.currentPage = 1
      }
      this.searchPromo();
    },
    editPromo(item){
      // console.log(">> EDIT:", item);
      this.$router.push(
        this.$route.query.redirectFrom || {
          name: "E-Load Lite SKU Form", params: { id: item.promoId }
        }
      );
    },
    async sortOptions(propName, arr) {
      // this function will sort dropdown options into ascending order

      arr.sort((a, b) => {
        const nameA = a[`${propName}`].toUpperCase(); // ignore upper and lowercase
        const nameB = b[`${propName}`].toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      return arr;
    },
    async toggleSinglePromo(promo, event) {
      if (!this.eloadPromoModule.access.update) {
        showAccessRestrictedModal();
        return;
      }

      // revert visual checkbox immediately to reflect actual model state
      try {
        event.target.checked = promo.promoStatus == 1;
      } catch (e) {
        // ignore if no event
      }

      const newStatus = promo.promoStatus == 1 ? 0 : 1;

      const confirmText = `Do you really want to ${newStatus == 1 ? 'activate' : 'deactivate'} this SKU?`;
      const confirmRes = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure?',
        text: confirmText,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#804997',
        cancelButtonColor: '#d33',
        reverseButtons: false
      });

      if (!confirmRes.isConfirmed) return;

      const params = {
        action: 'update-promo-status-mutation',
        body: {
          promoId: promo.promoId,
          promoStatus: newStatus,
          username: JSON.parse(localStorage.getItem('userData')).email
        }
      };

      try {
        const res = await this.updatePromoStatus(params);
        if (res.status == 'ok') {
          await Swal.fire({
            icon: 'success',
            title: 'Updated Successful!',
            text: `E-Load SKU is successfully ${newStatus == 1 ? 'activated.' : 'deactivated.'}`,
            confirmButtonText: 'OK',
            confirmButtonColor: '#804997'
          });
          await this.getPromoList();
        } else {
          Swal.fire('Failed', 'Could not update promo.', 'error');
        }
      } catch (e) {
        Swal.fire('Failed', 'Could not update promo.', 'error');
      }
    },
    
    highlightData(item) {
      let today = moment().format("YYYY-MM-DD")
      return moment(item.modifiedDate).format("YYYY-MM-DD") == today
    },
    
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2 mb-3">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{ loadPromoTotalRows }}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- Search and button -->
              <div class="col-md-8 col-sm-8 text-end mb-3"> 


                  

                  <a class="btn btn-secondary" @click="onPageUpdate()"
                    ><feather
                      type="refresh-ccw"
                      size="16"
                      class="icon nav-icon"
                    ></feather
                    >&nbsp;&nbsp; Refresh</a
                  >
              </div>
              <!-- end col buttons-->

              <div class="col-md-12 col-sm-12">
                 <div class="row mt-4">
                    <div class="col-md-4 ta-right">
                      <b-form-group description="Search Keyword">
                        <form class="d-flex" @submit.prevent="onPageUpdate('reset')">
                          <b-form-group id="input-group-3" label-for="input-3">
                            <b-form-select
                              class="form-select rounded-0 rounded-start shadow-none"
                              style="width: fit-content"
                              id="input-3"
                              v-model="searchValue.searchField"
                              :options="searchListPromo"
                            ></b-form-select>
                          </b-form-group>

                          <b-input-group>
                            <b-form-input
                              class="rounded-0"
                              v-model="searchValue.search"
                            ></b-form-input>
                          </b-input-group>
                        </form>
                      </b-form-group>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                        <div class="col-sm-3">
                          <b-form-group label-for="services" description="Filter by Service">
                            <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                              v-model="searchValue.service"
                              :options="eloadServiceOptions"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                        <div class="col-sm-3">
                          <b-form-group label-for="status" description="Filter by Status">
                            <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                              v-model="searchValue.status"
                              :options="statusList"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                        <div class="col-sm-3">
                          <b-form-group label-for="category" description="Filter by Category">
                            <b-form-select class="form-select rounded-0 rounded-start shadow-none" 
                              v-model="searchValue.category"
                              :options="categoryList"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                        <div class="col-sm-3">
                          <b-form-group label-for="network" description="Filter by Network">
                            <b-form-select id="network" class="form-select rounded-0 rounded-start shadow-none"
                              v-model="searchValue.network"
                              :options="eloadNetworkOptions"
                              @change="onNetworkChange"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                        <div class="col-sm-1" style="width: fit-content">
                            <b-button variant="primary" type="button" @click="onPageUpdate('reset')" class="px-2 d-flex align-items-center">
                              <div><i class='bx bx-search bx-fw'></i></div>
                              <div>Search</div>
                            </b-button>
                        </div>
                        <div class="col-sm-1" style="width: fit-content">
                            <b-button variant="primary" @click="onExport" type="button" class="px-2 d-flex align-items-center">
                              <div><i class='uil uil-export me-1'></i></div>
                              <div>Export</div>
                            </b-button>
                        </div>
                      </div>
                    </div>
                </div>

              </div> <!-- end of list of filter-->
            </div>
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="promos"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :no-local-sorting="true"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="eloadPromoSort"
                >
                  <template #cell(promoName)="data">
                    <b-link
                      class="fw-medium"
                      :class="{ 'fw-bold': highlightData(data.item) }"
                      @click="editPromo(data.item)"
                      :style="{ color: '#ff2d8b', fontWeight: highlightData(data.item) ? 700 : 600 }"
                    >
                      {{ data.item.promoName }}
                    </b-link>
                  </template>

                  <template #cell(promoId)="data">
                    <p class="text-muted m-0 small">{{ data.item.promoId }}</p>
                  </template>

                  <template #cell(promoCode)="data">
                    <p class="text-body m-0" :class="{ 'fw-bold': highlightData(data.item) }">
                      {{ data.item.promoCode }}
                    </p>
                  </template>
                  <template #cell(network)="data">
                    <p class="text-body fw-medium m-0" :class="{ 'fw-bold': highlightData(data.item) }">
                      {{ data.item.promoNetwork }}
                    </p>
                  </template>
                  <template #cell(service)="data">
                    <p class="text-body m-0" :class="{ 'fw-bold': highlightData(data.item) }">
                      {{ getServiceName(data.item.promoServiceId) || data.item.promoServiceName || '-' }}
                    </p>
                  </template>
                  
                  <template #cell(category)="data">
                    <div :class="{ 'fw-bold': highlightData(data.item) }">
                      <template v-if="data.item.promoCategories && Array.isArray(data.item.promoCategories) && data.item.promoCategories.length">
                        <div class="category-grid">
                          <span
                            v-for="(c, idx) in data.item.promoCategories"
                            :key="c.id || c.category_name || idx"
                            class="category-badge"
                            :title="c.category_name || c.categoryName || c"
                          >
                            {{ (c.category_name || c.categoryName || c) }}
                          </span>
                        </div>
                      </template>
                      <template v-else-if="data.item.promoCategory">
                        <div>
                          <span class="category-badge">{{ data.item.promoCategory }}</span>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template #cell(special_category)="data">
                    <p class="text-body m-0" :class="{ 'fw-bold': highlightData(data.item) }">
                      <template v-if="getSpecialCategories(data.item).length">
                        {{ getSpecialCategories(data.item).join(' ') }}
                      </template>
                    </p>
                  </template>

                  <template #cell(description)="data">
                    <p class="text-body m-0" :class="{ 'fw-bold': highlightData(data.item) }">
                      {{
                        String(data.item.promoDescription).length > 22
                          ? String(data.item.promoDescription).substring(
                              0,
                              22
                            ) + "..."
                          : data.item.promoDescription
                      }}
                    </p>
                  </template>

                  

                  <template #cell(validity)="data">
                    <p class="text-body m-0" :class="{ 'fw-bold': highlightData(data.item) }">{{ data.item.promoValidity }}</p>
                  </template>

                  <template #cell(input_type)="data">
                    <p class="text-body m-0" :class="{ 'fw-bold': highlightData(data.item) }">{{ data.item.promoInputType == "AN" ? "Account Number":"Mobile Number" }} -
                      <!-- ${data.item.promoMinChar} -  -->
                      {{ data.item.promoInputType == "AN" ? `${data.item.promoMaxChar}`:(data.item.promoMaxChar==null?11:data.item.promoMaxChar) }}
                    </p>
                  </template>

                  <template #cell(amount)="data">
                    <p class="text-body m-0 text-end" :class="{ 'fw-bold': highlightData(data.item) }">
                      <span class="">PHP&nbsp;</span
                      >{{ data.item.promoAmount }}
                    </p>
                  </template>

                  <template #cell(status)="data">
                    <div class="d-flex align-items-center">
                      <div class="form-check form-switch form-switch-md mb-1 me-2" dir="ltr">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :id="`promoSwitch_${data.item.promoId}`"
                          :checked="data.item.promoStatus == 1"
                          @change="toggleSinglePromo(data.item, $event)"
                        />
                      </div>
                      <div>
                        <span :class="data.item.promoStatus == 1 ? 'text-success' : 'text-muted'">
                          {{ data.item.promoStatus == 1 ? 'Active' : 'Active' }}
                        </span>
                      </div>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="loadPromoTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start"  v-if="loadPromoTotalRows != 0 && loadPromoTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="loadPromoTotalRows > perPage"
                    >
                      <!-- pagination 
                        im ded owahfoiahwfwaiofhaoi

                        -sean
                         -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="onPageUpdate()"
                        :total-rows="loadPromoTotalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>

<style>
.custom-checkbox label {
  margin: 0;
}
/* Category badge grid */
.category-grid {
  display: grid;
  grid-template-columns: repeat(3, max-content);
  gap: 0.35rem 0.6rem;
  align-items: center;
  grid-auto-rows: min-content;
}
.category-badge {
  background: #f6f7f8;
  color: var(--neutrals-neutral-600, #4B4B4B);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.12px;
  padding: .25rem .6rem;
  border-radius: 4px;
  display: inline-block;
  border: 1px solid rgba(0,0,0,0.04);
}

@media (max-width: 992px) {
  .category-grid {
    grid-template-columns: repeat(2, max-content);
  }
}

@media (max-width: 576px) {
  .category-grid {
    grid-template-columns: repeat(1, max-content);
  }
}
</style>